export default __webpack_public_path__ + "static/media/markerI_offline.26d89474.svg";